import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  InputBase,
  Paper,
  useMediaQuery,
  MenuItem,
  Pagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import StatusDropdown from "../../../../components/StatusDropdown";
import ExportDropdown from "../../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../../components/CustomText";
import { useTranslation } from "react-i18next";
import { Menu } from "@mui/material";
import DetailsDrawer from "./DetailsDrawer.js";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import empty from "../../../../assets/empty.png";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterDrawer from "./FilterDrawer"; //
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CircularProgress from "@mui/material/CircularProgress";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import ExportUnvalidatedPunchesExcel from "./PunchesExcel.js";
import ExportUnvalidatedPunchesPDF from "./PunchesPdf.js";
import { useCompanyProfile } from "../../../../components/CompanyProfile";
import back from "../../../../assets/back.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { pdf } from "@react-pdf/renderer";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";

/** StatusDropdown labelMap: keep palette keys (statusStyles) but show Half Day Leave in copy */
const UNVALIDATED_PUNCH_STATUS_LABEL_MAP = {
  Validated: "unvalidatedPunches.statusLabels.validatedPunch",
  Invalid: "unvalidatedPunches.statusLabels.unvalidatedPunch",
  Pending: "unvalidatedPunches.statusLabels.pendingPunch",
  "Half Day": "unvalidatedPunches.statusLabels.halfDayLeave",
  HALF_DAY: "unvalidatedPunches.statusLabels.halfDayLeave",
  "half day": "unvalidatedPunches.statusLabels.halfDayLeave",
  "HALF DAY": "unvalidatedPunches.statusLabels.halfDayLeave",
  halfDay: "unvalidatedPunches.statusLabels.halfDayLeave",
  halfday: "unvalidatedPunches.statusLabels.halfDayLeave",
};

const UnvalidatedPunches = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const itemsPerPage = 5;

  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const [punchesData, setPunchesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const [filterOpen, setFilterOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    startDate: "",
    endDate: "",
    worker_id: "",
  });

  const formatUtcTimeToLocal = (utcValue) => {
    const localValue = convertUTCToLocalDateTime(utcValue, {
      locale: "en-GB",
      formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
    });
    return localValue === "—" ? "-" : localValue;
  };

  const formatUtcDateTimeToLocal = (utcValue) => {
    const localValue = convertUTCToLocalDateTime(utcValue, {
      locale: "en-GB",
      formatOptions: {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      },
    });
    return localValue === "—" ? "—" : localValue.replace(",", " -");
  };

  const issueLabel = (issues = []) => {
    if (!issues.length) return "-";
    const map = {
      INVALID_LOCATION: "Invalid Location",
      INVALID_FACE: "Invalid Face",
      INVALID_SCHEDULE: "Invalid Schedule",
      BOTH_ISSUES: "Invalid Face & Location",
    };
    return map[issues[0]] || issues[0];
  };

  const apiStatusToUI = (reviewStatus) => {
    switch (reviewStatus) {
      case "PENDING":
        return "Pending";
      case "APPROVED":
        return "Validated";
      case "REJECTED":
        return "Invalid";
      default:
        return "Pending";
    }
  };

  const uiStatusToApi = (uiStatus) => {
    switch (String(uiStatus || "").toLowerCase()) {
      case "pending":
        return "PENDING";
      case "invalid":
        return "REJECTED";
      case "validated":
        return "APPROVED";
      default:
        return "";
    }
  };

  const fetchPunches = async (page = 1, size = itemsPerPage) => {
    setLoading(true);
    setError(null);
    try {
let url = `${BASE_URL}/company-admins/attendance/unvalidated?page=${page}&pageSize=${size}`;

if (filters.worker_id) url += `&worker_id=${filters.worker_id}`;
if (searchTerm.trim()) url += `&search=${encodeURIComponent(searchTerm.trim())}`;
const apiStatus = uiStatusToApi(filters.status);
if (apiStatus) url += `&status=${apiStatus}`;
if (filters.startDate) url += `&dateFrom=${filters.startDate}`;
if (filters.endDate) url += `&dateTo=${filters.endDate}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(decryptedToken ? { Authorization: `Bearer ${decryptedToken}` } : {}),
        },
      });
console.log("unvalidated table ",res);
      if (!res.ok) throw new Error(`Request failed (${res.status})`);

      const json = await res.json();
      console.log("unvalidated table 213671267371", json);

      const punches = json?.data?.punches ?? [];
      const pagination = json?.data?.pagination ?? {};
      const pageSize = pagination.pageSize || size;
      const totalRecords = pagination.totalRecords ?? 0;
      const pagesFromRecords =
        totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 0;
      const resolvedTotalPages =
        pagesFromRecords || pagination.totalPages || 1;

      const rows = punches.map((p) => {
        const dTime = formatUtcTimeToLocal(p.timestamps?.occurredAt || p.occurredAt);

        return {
          id: p.punchId ?? "-",
          fullName: p.worker?.fullName ?? "-",
          email: p.worker?.email ?? "—",
          date: p.occurredAt
            ? formatUtcDateTimeToLocal(p.occurredAt)
            : "—",
          checkIn: p.actionType === "CLOCK_IN" ? dTime : "-",
            breakStart: p.actionType === "BREAK_START" ? dTime : "-",
    breakEnd: p.actionType === "BREAK_END" ? dTime: "-",
          checkOut: p.actionType === "CLOCK_OUT" ? dTime : "-",
          location: p.location?.locationText ?? "-",
          details: issueLabel(p.validation?.validationIssues),
            reviewNote: p.validation?.reviewNote ?? "-",   
          status: apiStatusToUI(p.validation?.reviewStatus), // ✅ Matches drawer values now
          __raw: p,
        };
      });

      setPunchesData(rows);
      setTotalPages(resolvedTotalPages);
    } catch (e) {
      console.error(e);
      setError(e.message || "Failed to load");
      setPunchesData([]);
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  fetchPunches(currentPage, itemsPerPage);
}, [currentPage, filters, searchTerm]);

 useEffect(() => {
  if (currentPage > totalPages) {
    setCurrentPage(Math.max(1, totalPages));
  }
}, [totalPages, currentPage]);


  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedRowData(null);
  };
const [isFilterApplied, setIsFilterApplied] = useState(false);
  // const handleApplyFilters = (newFilters) => {
  //   console.log("✅ Received filters in parent:", newFilters);
  //   setFilters(newFilters);
  //   setCurrentPage(1);
  // };
const handleApplyFilters = (newFilters) => {
  console.log("✅ Received filters in parent:", newFilters);
  setFilters(newFilters);
  setCurrentPage(1); // reset to page 1

  // Check if any filter is actually set
  const applied =
    newFilters.status !== "" ||
    newFilters.startDate !== "" ||
    newFilters.endDate !== ""||
      newFilters.worker_id !== "";

  setIsFilterApplied(applied);
};

  const tableRows = () => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return punchesData;
    return punchesData.filter(
      (row) =>
        row.fullName.toLowerCase().includes(q) ||
        (row.email && String(row.email).toLowerCase().includes(q)) ||
        row.location.toLowerCase().includes(q) ||
        row.details.toLowerCase().includes(q)
    );
  };

  const HeaderStyles = {
    color: "#44546F",
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: "nowrap",
    textAlign:"center",
    overflow: "hidden",
    textOverflow: "ellipsis",
     paddingLeft:"10px",
    paddingRight:"10px"
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft:"10px",
    paddingRight:"10px"
  };

  const isMobile = useMediaQuery("(max-width:768px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  const handleViewClick = () => {
  if (menuRow) {
    setSelectedRowData(menuRow.id);  // pass punchId only
    setIsDetailModalOpen(true);
  }
  handleMenuClose();
};


// Fetch ALL punches for Excel & PDF (same as Departments)
const fetchAllPunches = async (decryptedToken, searchTerm, filters) => {
  const query = new URLSearchParams({
    no_pagination: "true",
  });

  // 🔥 Same filter logic as TABLE API
  if (searchTerm) query.append("search", searchTerm);
  const apiStatus = uiStatusToApi(filters.status);
  if (apiStatus) query.append("status", apiStatus);
  if (filters.startDate) query.append("dateFrom", filters.startDate);
  if (filters.endDate) query.append("dateTo", filters.endDate);
  if (filters.worker_id) query.append("worker_id", filters.worker_id);


  const url = `${BASE_URL}/company-admins/attendance/unvalidated?${query.toString()}`;
  console.log("📡 EXPORT API:", url);

  try {
    const res = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        ...(decryptedToken ? { Authorization: `Bearer ${decryptedToken}` } : {}),
      },
    });

    const json = await res.json();
    const punches = json?.data?.punches ?? [];

    return punches.map((p) => {
      const dTime = formatUtcTimeToLocal(p.timestamps?.occurredAt || p.occurredAt);

      return {
        id: p.punchId ?? "-",
        fullName: p.worker?.fullName ?? "-",
        email: p.worker?.email ?? "—",
        date: p.occurredAt
          ? formatUtcDateTimeToLocal(p.occurredAt)
          : "—",
        checkIn: p.actionType === "CLOCK_IN" ? dTime : "-",
        checkOut: p.actionType === "CLOCK_OUT" ? dTime : "-",
       breakStart: p.actionType === "BREAK_START" ? dTime : "-",
    breakEnd: p.actionType === "BREAK_END" ?dTime : "-",
        location: p.location?.locationText ?? "-",
        details: issueLabel(p.validation?.validationIssues),
        reviewNote: p.validation?.reviewNote ?? "-",
        status: apiStatusToUI(p.validation?.reviewStatus),
      };
    });
  } catch (err) {
    console.error("❌ Export error:", err);
    return [];
  }
};


const { logoBase64,  } = useCompanyProfile(decryptedToken);


  return (

    <>
              {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        border: "2px solid #091E4224",
        py: 2,
        ml: 1,
        mr: 1,
        mt: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
        }}
      >
        {/* Left: Title */}
        <Box sx={{ flex: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
              textAlign: "left",
            }}
          >
            {t("unvalidatedPunches.title")}
          </CustomText>
        </Box>

        {/* Center: Search */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              px: 1,
              py: 0.2,
              borderRadius: 1,
              height: 34,
              border: "2px solid #091E4224",
              display: "flex",
              alignItems: "center",
              minWidth: 250,
              width: "100%",
              maxWidth: 300,
            }}
          >
            <InputBase
              placeholder={t("unvalidatedPunches.searchPlaceholder")}
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              sx={{
                ml: 0.5,
                fontSize: 15,
                fontFamily: "Poppins, sans-serif",
                color: "#939393",
                fontWeight: 400,
                width: "100%",
              }}
            />
            <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
          </Box>
        </Box>

        {/* Right: Export & Filter */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
<ExportDropdown
onDownloadPDF={async () => {
  const allData = await fetchAllPunches(decryptedToken, searchTerm, filters);

  const blob = await pdf(
    <ExportUnvalidatedPunchesPDF data={allData} logo={logoBase64}/>
  ).toBlob();

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `Punches_${new Date().toISOString().slice(0, 10)}.pdf`;
  link.click();
}}

onDownloadExcel={async () => {
  const allData = await fetchAllPunches(decryptedToken, searchTerm, filters);
  ExportUnvalidatedPunchesExcel(allData);
}}
/>
          {/* <IconButton onClick={() => setFilterOpen(true)}>
            <FilterListIcon />
          </IconButton> */}
          {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#1976d2", // blue background when applied
    }}
  >
    {/* Filter Icon (white) */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Cross Icon (to clear filters) */}
    <IconButton
      size="small"
      onClick={() => {
        setFilters({
          status: "",
          startDate: "",
          endDate: "",
          worker_id: "",
        });
        setCurrentPage(1);
        setIsFilterApplied(false);
      }}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
    }}
  >
    <FilterAltIcon />
  </IconButton>
)}
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>

          {loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 300, // enough space for loader
      }}
    >
      <CircularProgress color="primary" />
    </Box>
    ) : punchesData.length === 0 ? (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
    }}
  >
    <img src={empty} alt="No Data" style={{ width: 200, marginBottom: 16 }} />
    <CustomText
      sx={{
        ...textStyles.h1,
        fontWeight: 500,
        fontSize: "16px",
        color: "#003149",
      }}
    >
    {t("empty.no_user")}    </CustomText>
  </Box>

  ) : (
        <Table 
          sx={{
    borderCollapse: "separate",
    borderSpacing: "0 3px", // row gap (vertical space)
    "& td, & th": {
      paddingLeft: "14px", // left/right column gap
      paddingRight: "14px",
    },
  }}>
          <TableHead
            sx={{
              borderTop: "2px solid #091E4224",
              borderBottom: "2px solid #091E4224",
            }}
          >
            <TableRow>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2, pl: 1.5 }}>
                {t("unvalidatedPunches.tableHeaders.id")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.fullName")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.email")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.date")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("ClockIn")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
  {t("StartBreak")}
</TableCell>
<TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
  {t("EndBreak")}
</TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("ClockOut")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.location")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.details")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
  {t("unvalidatedPunches.tableHeaders.reviewNote") || "Review Note"}
</TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.status")}
              </TableCell>
              <TableCell sx={{ ...HeaderStyles, py: "6px", px: "2px", pt: 2 }}>
                {t("unvalidatedPunches.tableHeaders.action")}
              </TableCell>
            </TableRow>
          </TableHead>

          {!loading && !error && tableRows().length === 0 ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={12}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 5,
                    }}
                  >
                    <img
                      src={empty}
                      alt="No Data"
                      style={{ width: 200, marginBottom: 16 }}
                    />
                    <CustomText
                      sx={{
                        ...textStyles.h1,
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#003149",
                      }}
                    >
                      {t("empty.no_user")}
                    </CustomText>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {tableRows().map((row, index) => (
                <TableRow key={`${row.id}-${index}`}>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px", pl: 1.5 }}>
                    {row.id}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    {row.fullName}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    <Typography sx={{ ...DataStyles }} title={row.email}>
                      <TruncatedCell text={row.email} />
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    {row.date}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    {row.checkIn}
                  </TableCell>
                  <TableCell sx={DataStyles}>
  {row.breakStart}
</TableCell>

<TableCell sx={DataStyles}>
  {row.breakEnd}
</TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    {row.checkOut}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    <Typography sx={{ ...DataStyles }} title={row.location}>
                      {/* {row.location} */}
                        <TruncatedCell text={row.location} />
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    <Typography sx={{ ...DataStyles }}>
                      {/* {row.details} */}
                        <TruncatedCell text={row.details} />
                      </Typography>
                  </TableCell>
                   <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
                    <Typography sx={{ ...DataStyles }}> 
                      {/* {row.reviewNote} */}
                        <TruncatedCell text={row.reviewNote} />

                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: "6px", px: "4px" }}>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown
                        currentStatus={row.status}
                        labelMap={UNVALIDATED_PUNCH_STATUS_LABEL_MAP}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={(e) => handleMenuOpen(e, row)}>
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
          )}
      </TableContainer>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={handleViewClick}
          sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}
        >
          {t("unvalidatedPunches.tableActions.view")}
        </MenuItem>
      </Menu>

      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, value) => setCurrentPage(value)}
          shape="rounded"
          color="primary"
          size="small"
          sx={{
            "& .MuiPaginationItem-root": {
              fontFamily: "Poppins, sans-serif",
              fontSize: 13,
              fontWeight: 500,
            },
            "& .Mui-selected": {
              backgroundColor: "#E9F3FF",
              color: "#006EC2",
            },
          }}
        />
      </Box>

      {isDetailModalOpen && selectedRowData && (
        <DetailsDrawer
          open={isDetailModalOpen}
          onClose={handleCloseDetailModal}
           punchId={selectedRowData} 
            onStatusChange={fetchPunches}  
        />
      )}

      <FilterDrawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        filters={filters}
        setFilters={setFilters}
        onApplyFilters={handleApplyFilters}
      />
    </Box>
    </>
  );
};

export default UnvalidatedPunches;


